module.exports = __webpack_public_path__ + "img/usd-level-4.d878536a.webp";